import React from "react";
import { Link } from "react-router-dom";

export default function RelatedPost({ relatedBlog }) {
  const { id, title, tags, image, createdAt } = relatedBlog;
  return (
    <div className="card">
      <Link to={`/post/${id}`}>
        <img src={image} className="card-image" alt={title} />
      </Link>
      <div className="p-4">
        <Link
          to={`/post/${id}`}
          className="text-lg post-title lws-RelatedPostTitle"
        >
          {title}
        </Link>
        <div className="mb-0 tags">
          {tags?.map((tag, i) => {
            // if its the last tag then dont' add comma
            if (tags.length === i + 1) {
              return <span key={i}>#{tag} </span>;
            } else {
              return <span key={i}>#{tag + ","} </span>;
            }
          })}
        </div>
        <p>{createdAt}</p>
      </div>
    </div>
  );
}
